<div class="container h-100 d-flex align-items-center p-5">
    <mat-spinner [diameter]="60" [strokeWidth]="3" class="mx-auto"></mat-spinner>
</div>